import React from 'react';
import { Box, Button, IconButton, TextField } from "@mui/material";
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Grid from '@mui/material/Grid';
// import { DataGrid } from '@mui/x-data-grid';
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import axios from "../../../utils/fvAxios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ErrorAlert from "../../../toolkit/ErrorAlert";
import {
  Collapse,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { debounce } from 'lodash';
import Paginator from '../../../toolkit/Paginator';
import { getisEmp, getMoodleUserId } from '../../../utils/Token';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F9FAFB",
    color: "#667085",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));







const Row = ({ group, transactions, getC, paidperclients }) => {
  const [open, setOpen] = useState(false);
  const [transactions1, settransactions1] = useState([]);

  const groupedTransactions = transactions?.reduce((groups, row) => {
    const key = `${row?.paymentReceivedon}-${row?.transactionID}-${row?.subTotal}-${row?.commision}-${row?.total}`;
    if (!groups[key]) {
      groups[key] = [row];
    } else {
      groups[key]?.push(row);
    }
    return groups;
  }, {});


  useEffect(() => {
    settransactions1(paidperclients)
  }, [paidperclients]);

  // useEffect(() => {
  // axios
  //   .get("Employee/GetTrainingAmountPaidperClient?transactionid=" + test)
  //   .then((res) => {
  //     if (res.data.responseCode === 100) {
  //       settransactions1(res?.data?.data);
  //     } else {
  //     }
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   })
  // }, [test]);

  // const groupedTransactionss = transactions1.reduce((acc, transaction) => {
  //   const key = transaction?.transactionId;
  //   if (!acc[key]) {
  //     acc[key] = [];
  //   }
  //   acc[key].push(transaction);
  //   return acc;
  // }, {});

  return (
    <>
      {Object?.values(groupedTransactions)?.map((group, index) => (
        <TableRow key={index}>
          <TableCell>
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell>
            {group?.every((transaction) => transaction?.clientNames === group[0]?.clientNames) ? (
              group[0]?.clientNames
            ) : (
              <div>
                {Array.from(new Set(group?.map(transaction => transaction?.clientNames)))
                  ?.slice(0, 2)
                  ?.map((clientName, innerIndex) => (
                    <div key={innerIndex}>{clientName}</div>
                  ))}
                {Array?.from(new Set(group?.map(transaction => transaction?.clientNames)))?.length > 2 && (
                  <div title={Array?.from(new Set(group?.slice(2)?.map(transaction => transaction?.clientNames)))?.join(', ')}>
                    <span>...</span>
                  </div>
                )}
              </div>
            )}
          </TableCell>


          <TableCell>{group[0]?.paymentReceivedon}</TableCell>
          <TableCell>{group[0]?.transactionID}</TableCell>
          <TableCell>${(group[0]?.subTotal)?.toFixed(2)}</TableCell>
          <TableCell>- ${(group[0]?.commision)?.toFixed(2)}</TableCell>
          <TableCell>${(group[0]?.total?.toFixed(2))}</TableCell>
          <TableCell style={{ width: "300px" }}>
            {transactions1?.map(transaction => {
              if (transaction?.transactionId === group[0]?.transactionID) {
                return (group[0]?.transactionID === "-1" ? "" : transaction?.amountPaidPerClient?.slice(0, -2));
              }
              return "";
            })
              ?.filter(amount => amount !== "")
              ?.join(", ")
            }
          </TableCell>
          <TableCell>{group[0]?.paymentMadeBy}</TableCell>
        </TableRow>
      ))}




      <TableCell style={{ paddingBottom: 0, paddingTop: 0, }} colSpan={12}>

        <Collapse in={open} timeout="auto" unmountOnExit style={{ marginTop: "20px", marginBottom: "20px" }}>
          <TableHead style={{ marginTop: "20px" }}>
            <TableRow>
              <StyledTableCell style={{ width: "400px" }}>Client</StyledTableCell>
              <StyledTableCell style={{ width: "400px" }}>Employee Name</StyledTableCell>
              <StyledTableCell style={{ width: "400px" }}>Quiz Name</StyledTableCell>
              <StyledTableCell style={{ width: "400px" }}>Amount paid</StyledTableCell>
            </TableRow>
          </TableHead>


          {transactions?.map((row) => (
            <TableRow>

              <TableCell>{row?.clientNames}</TableCell>
              <TableCell>{row?.employeeName}</TableCell>
              <TableCell>{row?.courseName}</TableCell>
              <TableCell>${row?.actualAmountPaid?.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </Collapse>
      </TableCell>

    </>
  );
};

export default function PaymentHistory() {


  const [getCourse, setCourses] = React.useState([]);
  const [spinner, setSpinner] = React.useState(false);
  const [pagenumber, setPagenumber] = React.useState();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isdata, setIsdata] = useState(true);
  const [text, settext] = useState('');
  const [filter, setfilter] = useState('');
  const [ids, setids] = useState('');
  const [paidperclient, setpaidperclient] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  const handlePageChange = (newPage) => {
    setIsLoading(true)
    setCurrentPage(newPage);

  };

  // const { data: res } = useFetch("Employee/GetQuizPaymentHistory?pageNumber=" + currentPage + "&size=" + itemsPerPage);

  // useEffect(() => {

  //   try {

  //     if (res?.data) {
  //       setCourses(res?.data);
  //       setPagenumber(res?.count);
  //       const transactionIDs = res?.data?.map(item => item.transactionID);
  //       const uniqueTransactionIDs = [...new Set(transactionIDs)]; /
  //       const transactionIDsString = uniqueTransactionIDs.join(',');
  //       setids(transactionIDsString);
  //       axios
  //       .get("Employee/GetTrainingAmountPaidperClient?transactionid=" + transactionIDsString)
  //       .then((resp) => {
  //         if (resp.data.responseCode === 100) {
  //           setpaidperclient(resp?.data?.data);
  //           debugger;
  //         } else {
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       })



  //     }
  //   } finally {

  //     // setIsdata(false)
  //     setTimeout(() => {
  //       setIsLoading(false);
  //       setIsdata(false)
  //     }, 5000)
  //   }
  // }, [res]);

  // const handleKeyPress = (event, va) => {
  //   if (event.key === 'Enter' || "true") {
  //     // handleChange(event.target.value);
  //     setSpinner(true);
  //     // setCurrentPage(1);
  //     setIsLoading(true);
  //     if (va?.length === 0) {
  //       axios
  //         .get("Employee/GetQuizPaymentHistory?pageNumber=" + currentPage + "&size=" + itemsPerPage)
  //         .then((resp) => {
  //           if (resp.data) {
  //             setCourses(resp?.data?.data);
  //             setPagenumber(resp?.data?.count);

  //             const transactionIDs = resp?.data?.data.map(item => item.transactionID);
  //             const uniqueTransactionIDs = [...new Set(transactionIDs)]; // Remove duplicates
  //             const transactionIDsString = uniqueTransactionIDs.join(','); // Join with commas
  //             setids(transactionIDsString);
  //             axios
  //             .get("Employee/GetTrainingAmountPaidperClient?transactionid=" + transactionIDsString)
  //             .then((res) => {
  //               if (res.data.responseCode === 100) {
  //                 setpaidperclient(res?.data?.data);
  //               } else {
  //               }
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //             })
  //           } else {
  //             setError(resp.data.responseMessage);
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         }).finally(() => {
  //           setIsLoading(false);
  //         })
  //     }
  //     else {
  //       axios
  //         .get("Employee/GetQuizPaymentHistory?pageNumber=" + currentPage + "&size=" + itemsPerPage + "&filter=" + va)
  //         .then((resp) => {
  //           if (resp.data) {
  //             setCourses(resp?.data?.data);
  //             setPagenumber(resp?.data?.count);

  //             const transactionIDs = resp?.data?.data.map(item => item.transactionID);
  //             const uniqueTransactionIDs = [...new Set(transactionIDs)]; // Remove duplicates
  //             const transactionIDsString = uniqueTransactionIDs.join(','); // Join with commas
  //             axios
  //             .get("Employee/GetTrainingAmountPaidperClient?transactionid=" + transactionIDsString)
  //             .then((res) => {
  //               if (res.data.responseCode === 100) {
  //                 setpaidperclient(res?.data?.data);
  //               } else {
  //               }
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //             })
  //           } else {
  //             setError(resp.data.responseMessage);
  //           }
  //         })
  //         .catch((err) => {
  //           console.log(err);
  //         }).finally(() => {
  //           setIsLoading(false);
  //         });
  //     }
  //   }
  // };

  useEffect(() => {
    if (filter.length == 0) {
      axios.get("Employee/GetQuizPaymentHistory?pageNumber=" + currentPage + "&size=" + itemsPerPage
      ).then(res => {
        setCourses(res?.data?.data);
        setPagenumber(res?.data?.count);
        const transactionIDs = res?.data?.data?.map(item => item?.transactionID);
        const uniqueTransactionIDs = [...new Set(transactionIDs)];
        const transactionIDsString = uniqueTransactionIDs.join(',');
        setids(transactionIDsString);
        axios.get("Employee/GetTrainingAmountPaidperClient?transactionid=" + transactionIDsString)
          .then((resp) => {
            if (resp?.data?.responseCode === 100) {
              setpaidperclient(resp?.data?.data);

            } else {
            }
          })
          .catch((err) => {
            console.log(err);
          }).finally(() => {
            setIsLoading(false);
          })


      }).catch(err => {
        console.log(err)
      })
    }
    else {
      if (text == filter) {
        setIsLoading(true)
        axios.get("Employee/GetQuizPaymentHistory?pageNumber=" + currentPage + "&size=" + itemsPerPage + "&filter=" + filter
        ).then(res => {
          setCourses(res?.data?.data);
          setPagenumber(res?.data?.count);
          const transactionIDs = res?.data?.data?.map(item => item?.transactionID);
          const uniqueTransactionIDs = [...new Set(transactionIDs)];
          const transactionIDsString = uniqueTransactionIDs?.join(',');
          setids(transactionIDsString);
          axios.get("Employee/GetTrainingAmountPaidperClient?transactionid=" + transactionIDsString)
            .then((resp) => {
              if (resp?.data?.responseCode === 100) {
                setpaidperclient(resp?.data?.data);

              } else {
              }
            })
            .catch((err) => {
              console.log(err);
            }).finally(() => {
              setIsLoading(false);
            })


        }).catch(err => {
          console.log(err)
        })
      }
    }
  }, [text, currentPage, filter]);

  // const handleChange = (va) => {
  //   console.log(va);
  //   setCurrentPage(1);
  //   settext(va);


  // };
  const debouncedHandleChange = debounce((value) => {
    setCurrentPage(1);
    setfilter(value)
  }, 1000);

  const handleChange = (event) => {
    const value = event?.target?.value;
    debouncedHandleChange(value);

    settext(value);
  };

  const groupedData = getCourse?.reduce((acc, row) => {
    const groupKey = `${row?.transactionID}_${row?.mcpid}_${row?.total}_${row?.paymentReceivedon}`;

    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }

    acc[groupKey]?.push(row);
    return acc;
  }, {});

  const groups = Object?.keys(groupedData);

  return (

    <Box sx={{ padding: "20px" }}>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
        <span style={{ fontSize: "18px", fontWeight: "500", color: "#3E4A62" }}>
          Quiz Payments
        </span>
        <span style={{ fontSize: "18px", fontWeight: "500", color: "#3E4A62", float: "right" }} >Total Payments : {pagenumber}</span>
        <hr sx={{ backgroundColor: "#E4E7EC;", height: "1px" }} />
        <div>
          <Box>
            <Grid container >
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3} >
                    <TextField
                      variant="outlined"
                      sx={{ width: "300px", marginBottom: "20px" }}
                      placeholder="Search"
                      size="small"
                      type="text"
                      value={text}
                      inputProps={{
                        autoComplete: 'off'
                      }}

                      onChange={(event) => handleChange(event)}
                    />
                  </Grid>
                </Grid>
              </Grid>


            </Grid>

          </Box>
        </div>

        <TableContainer component={Paper} hidden={getCourse?.length === 0 || isLoading}>

          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell />
                <StyledTableCell>Clients</StyledTableCell>
                <StyledTableCell>Date</StyledTableCell>
                <StyledTableCell>Transaction ID</StyledTableCell>
                <StyledTableCell>Actual Amount</StyledTableCell>
                <StyledTableCell>Discount</StyledTableCell>
                <StyledTableCell>Total</StyledTableCell>
                <StyledTableCell >Amount Paid Per Client</StyledTableCell>
                <StyledTableCell >Paid By </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {groups?.map((group) => (
                <Row key={group} group={group} transactions={groupedData[group]} getC={ids} paidperclients={paidperclient} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <div hidden={getCourse?.length !== 0 || isLoading}>
          <ErrorAlert severity="warning" message={"No results found!"} /></div>
        <br />
        <div hidden={getCourse?.length === 0 || isLoading}>
          <Paginator
            hidden={getCourse?.length === 0 || isLoading}
            count={Math?.ceil(pagenumber / itemsPerPage)}
            page={currentPage}
            size="small"
            onChange={handlePageChange}
          />
        </div>
      </Box>
    </Box>
  )
}